export class MessaggioErroreVO {
  messaggio: string;
  warning: boolean;
}
